<!-- Fixed navbar -->
<nav class="navbar">
    <div class="container-fluid">
        <button class="btn btn-link btn-square menu-btn" type="button" (click)="menuopen()">
            <i class="bi bi-list fs-4"></i>
        </button>

        <div class="header-title align-self-center ms-2">
            <h5 class="mb-0">{{titlepage}}</h5>
            <p class="text-secondary small">{{subtitle}}</p>
        </div>

        <div *ngIf="false" class="search-header d-none d-xl-block ms-xl-3" id="search-header" [ngClass]="{'active':openSearch}">
            <div class="input-group input-group-md w-300">
                <span class="input-group-text text-theme"><i class="bi bi-search"></i></span>
                <input class="form-control pe-0" type="search" placeholder="Type something here..." [(ngModel)]="searchText" id="searchglobal" (keyup)="searching()">
                <div class="dropdown input-group-text rounded">
                    <button class="btn btn-link dd-arrow-none dropdown-toggle" type="button" id="searchfilter" data-bs-toggle="dropdown" data-bs-autoClose="false" aria-expanded="false" (click)="showSearchResult = false">
                        <i class="bi bi-sliders"></i>
                    </button>
                    <form class="dropdown-menu dropdown-menu-end dropdown-dontclose mt-2 w-300" (click)="dontclose($event)" aria-labelledby="searchfilter">
                        <ul class="nav nav-adminux" id="searchtab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="searchall-tab" data-bs-toggle="tab" data-bs-target="#searchall" type="button" role="tab" aria-controls="searchall" aria-selected="true">All</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="searchorders-tab" data-bs-toggle="tab" data-bs-target="#searchorders" type="button" role="tab" aria-controls="searchorders" aria-selected="false">Orders</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="searchcontacts-tab" data-bs-toggle="tab" data-bs-target="#searchcontacts" type="button" role="tab" aria-controls="searchcontacts" aria-selected="false">Contacts</button>
                            </li>
                        </ul>
                        <div class="tab-content py-3" id="searchtabContent">
                            <div class="tab-pane fade show active" id="searchall" role="tabpanel" aria-labelledby="searchall-tab">
                                <div class="dropdown-item mb-3">
                                    <div class="input-group input-group-md border rounded">
                                        <span class="input-group-text text-theme"><i class="bi bi-code-square"></i></span>
                                        <select class="form-control simplechosen">
                                            <option>Successful Order</option>
                                            <option>Full-filled Order</option>
                                            <option>Rejected Order</option>
                                            <option>Delivery Staff</option>
                                            <option>PM Employees</option>
                                        </select>
                                    </div>
                                </div>
                                <ul class="list-group list-group-flush bg-none">
                                    <li class="list-group-item">
                                        <div class="row">
                                            <div class="col">Search apps</div>
                                            <div class="col-auto">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="searchswitch1">
                                                    <label class="form-check-label" for="searchswitch1"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item">
                                        <div class="row">
                                            <div class="col">Include Pages</div>
                                            <div class="col-auto">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="searchswitch2" checked>
                                                    <label class="form-check-label" for="searchswitch2"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item">
                                        <div class="row">
                                            <div class="col">Internet resource</div>
                                            <div class="col-auto">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="searchswitch3" checked>
                                                    <label class="form-check-label" for="searchswitch3"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item">
                                        <div class="row">
                                            <div class="col">News and Blogs</div>
                                            <div class="col-auto">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="searchswitch4">
                                                    <label class="form-check-label" for="searchswitch4"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="tab-pane fade" id="searchorders" role="tabpanel" aria-labelledby="searchorders-tab">
                                <div class="dropdown-item mb-3">
                                    <div class="input-group input-group-md border rounded">
                                        <span class="input-group-text text-theme"><i class="bi bi-box"></i></span>
                                        <select class="form-control" id="searchfilterlist" multiple>
                                            <option value="San Francisco">San Francisco</option>
                                            <option value="New York">New York</option>
                                            <option value="Seattle" selected>Seattle</option>
                                            <option value="Los Angeles">Los Angeles</option>
                                            <option value="Chicago">Chicago</option>
                                            <option value="India">India</option>
                                            <option value="Sydney">Sydney</option>
                                            <option value="London">London</option>
                                            <option value="Indonesia">Indonesia</option>
                                            <option value="Los Angeles">Los Angeles</option>
                                            <option value="Chicago">Chicago</option>
                                            <option value="India">India</option>
                                        </select>
                                    </div>
                                    <div class="invalid-feedback">You have already selected maximum option allowed.(This is Configurable)</div>
                                </div>
                                <ul class="list-group list-group-flush bg-none">
                                    <li class="list-group-item">
                                        <div class="row">
                                            <div class="col">Show order ID</div>
                                            <div class="col-auto">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="searchswitch5">
                                                    <label class="form-check-label" for="searchswitch5"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item">
                                        <div class="row">
                                            <div class="col">International Order</div>
                                            <div class="col-auto">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="searchswitch6" checked>
                                                    <label class="form-check-label" for="searchswitch6"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item">
                                        <div class="row">
                                            <div class="col">Taxable Product</div>
                                            <div class="col-auto">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="searchswitch7" checked>
                                                    <label class="form-check-label" for="searchswitch7"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item">
                                        <div class="row">
                                            <div class="col">Published Product</div>
                                            <div class="col-auto">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="searchswitch8">
                                                    <label class="form-check-label" for="searchswitch8"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="tab-pane fade" id="searchcontacts" role="tabpanel" aria-labelledby="searchcontacts-tab">
                                <div class="dropdown-item mb-3">
                                    <div class="input-group input-group-md border rounded">
                                        <span class="input-group-text text-theme"><i class="bi bi-person-lines-fill"></i></span>
                                        <input class="form-control" type="search" placeholder="Contact Include">
                                    </div>
                                </div>
                                <ul class="list-group list-group-flush bg-none">
                                    <li class="list-group-item">
                                        <div class="row">
                                            <div class="col">Have email ID</div>
                                            <div class="col-auto">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="searchswitch9">
                                                    <label class="form-check-label" for="searchswitch9"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item">
                                        <div class="row">
                                            <div class="col">Have phone number</div>
                                            <div class="col-auto">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="searchswitch10" checked>
                                                    <label class="form-check-label" for="searchswitch10"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item">
                                        <div class="row">
                                            <div class="col">Photo available</div>
                                            <div class="col-auto">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="searchswitch11" checked>
                                                    <label class="form-check-label" for="searchswitch11"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item">
                                        <div class="row">
                                            <div class="col">Referral</div>
                                            <div class="col-auto">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="searchswitch12">
                                                    <label class="form-check-label" for="searchswitch12"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="dropdown-item">
                            <div class="row">
                                <div class="col"><button class="btn btn-outline-secondary border">Reset</button></div>
                                <div class="col-auto">
                                    <button class="btn btn-theme">Apply</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <span class="input-group-text d-flex d-xl-none c-pointer" (click)="openSearch=false;" id="searchclose">
                    <i class="bi bi-x-lg vm"></i>
                </span>
            </div>
            <div class="dropdown-menu dropdown-dontclose mt-2 mw-600 w-auto" id="searchresultglobal" [ngClass]="{'show': showSearchResult}">
                <ul class="nav nav-adminux" id="searchtab1" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="searchall1-tab" data-bs-toggle="tab" data-bs-target="#searchall1" type="button" role="tab" aria-controls="searchall1" aria-selected="true">All <span class="badge rounded-pill bg-success ml-2 vm">12</span></button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="searchorders1-tab" data-bs-toggle="tab" data-bs-target="#searchorders1" type="button" role="tab" aria-controls="searchorders1" aria-selected="false">Orders <span class="badge rounded-pill bg-primary ml-2 vm">8</span></button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="searchcontacts1-tab" data-bs-toggle="tab" data-bs-target="#searchcontacts1" type="button" role="tab" aria-controls="searchcontacts1" aria-selected="false">Contacts <span class="badge rounded-pill bg-warning ml-2 vm">4</span></button>
                    </li>
                </ul>
                <div class="tab-content py-3" id="searchtabContent1">
                    <div class="tab-pane fade show active mh-500 overflow-y-auto" id="searchall1" role="tabpanel" aria-labelledby="searchall1-tab">
                        <div class="container-fluid">
                            <div class="row mb-2">
                                <div class="col align-self-center">
                                    <h6>Application</h6>
                                </div>
                                <div class="col-auto">
                                    <a href="#" class="btn btn-sm btn-outline-secondary border">View all</a>
                                </div>
                            </div>
                            <div class="row g-0 text-center mb-3">
                                <div class="col-4 col-sm-2 col-md-2">
                                    <a class="dropdown-item square-item" href="app-finance.html">
                                        <div class="avatar avatar-40 rounded mb-2">
                                            <i class="bi bi-bank fs-4"></i>
                                        </div>
                                        <p class="mb-0">Finance</p>
                                        <p class="fs-12 text-muted">Accounting</p>
                                    </a>
                                </div>
                                <div class="col-4 col-sm-2 col-md-2">
                                    <a class="dropdown-item square-item" href="app-network.html">
                                        <div class="avatar avatar-40 rounded mb-2">
                                            <i class="bi bi-globe fs-4"></i>
                                        </div>
                                        <p class="mb-0">Network</p>
                                        <p class="fs-12 text-muted">Stabilize</p>
                                    </a>
                                </div>
                                <div class="col-4 col-sm-2 col-md-2">
                                    <a class="dropdown-item square-item" href="app-ecommerce.html">
                                        <div class="avatar avatar-40 rounded mb-2">
                                            <i class="bi bi-box fs-4"></i>
                                        </div>
                                        <p class="mb-0">Inventory</p>
                                        <p class="fs-12 text-muted">Assuring</p>
                                    </a>
                                </div>
                                <div class="col-4 col-sm-2 col-md-2">
                                    <a class="dropdown-item square-item" href="app-project.html">
                                        <div class="avatar avatar-40 rounded mb-2">
                                            <i class="bi bi-folder fs-4"></i>
                                        </div>
                                        <p class="mb-0">Project</p>
                                        <p class="fs-12 text-muted">Management</p>
                                    </a>
                                </div>
                                <div class="col-4 col-sm-2 col-md-2">
                                    <a class="dropdown-item square-item" href="app-social.html">
                                        <div class="avatar avatar-40 rounded mb-2">
                                            <i class="bi bi-people fs-4"></i>
                                        </div>
                                        <p class="mb-0">Social</p>
                                        <p class="fs-12 text-muted">Tracking</p>
                                    </a>
                                </div>
                                <div class="col-4 col-sm-2 col-md-2">
                                    <a class="dropdown-item square-item" href="app-learning.html">
                                        <div class="avatar avatar-40 rounded mb-2">
                                            <i class="bi bi-journal-bookmark fs-4"></i>
                                        </div>
                                        <p class="mb-0">Learning</p>
                                        <p class="fs-12 text-muted">Make-easy</p>
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col align-self-center">
                                    <h6>Orders Placed</h6>
                                </div>
                                <div class="col-auto">
                                    <a href="#" class="btn btn-sm btn-outline-secondary border">View all</a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="row mb-3">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme">
                                                <i class="bi bi-bag fs-5"></i>
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">#EDR0021 by John Merchant</a>
                                            <p class="text-truncate text-secondary small">2 items, $250.00, 09 December 2021</p>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme">
                                                <i class="bi bi-basket fs-5"></i>
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">#EDR0026 by Will Smith</a>
                                            <p class="text-truncate text-secondary small">4 items, $530.00, 18 December 2021</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="row mb-3">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme">
                                                <i class="bi bi-cart fs-5"></i>
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">#EDR0030 by Switty David</a>
                                            <p class="text-truncate text-secondary small">1 items, $50.00, 20 December 2021</p>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme">
                                                <i class="bi bi-cart4 fs-5"></i>
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">#EDR0041 by Mr.Walk Wolf</a>
                                            <p class="text-truncate text-secondary small">3 items, $130.00, 16 December 2021</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col align-self-center">
                                    <h6>Contacts</h6>
                                </div>
                                <div class="col-auto">
                                    <a href="#" class="btn btn-sm btn-outline-secondary border">View all</a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="row mb-3">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme coverimg">
                                                <img src="assets/img/user-2.jpg" alt="" />
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">Ms. Switty David</a>
                                            <p class="text-truncate text-secondary small">US, UK Recruiter</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme coverimg">
                                                <img src="assets/img/user-3.jpg" alt="" />
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">Dyna Roosevelt</a>
                                            <p class="text-truncate text-secondary small">Marketing Head at Linmongas</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="row mb-3">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme coverimg">
                                                <img src="assets/img/user-4.jpg" alt="" />
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">Mr. Freddy Johnson</a>
                                            <p class="text-truncate text-secondary small">Project Manager</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme coverimg">
                                                <img src="assets/img/user-1.jpg" alt="" name="userimage" />
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">The Maxartkiller</a>
                                            <p class="text-truncate text-secondary small">CEO Maxartkiller</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="searchorders1" role="tabpanel" aria-labelledby="searchorders1-tab">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="row mb-3">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme">
                                                <i class="bi bi-bag fs-5"></i>
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">#EDR0021 by John Merchant</a>
                                            <p class="text-truncate text-secondary small">2 items, $250.00, 09 December 2021</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme">
                                                <i class="bi bi-basket fs-5"></i>
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">#EDR0026 by Will Smith</a>
                                            <p class="text-truncate text-secondary small">4 items, $530.00, 18 December 2021</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="row mb-3">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme">
                                                <i class="bi bi-cart fs-5"></i>
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">#EDR0030 by Switty David</a>
                                            <p class="text-truncate text-secondary small">1 items, $50.00, 20 December 2021</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme">
                                                <i class="bi bi-cart4 fs-5"></i>
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">#EDR0041 by Mr.Walk Wolf</a>
                                            <p class="text-truncate text-secondary small">3 items, $130.00, 16 December 2021</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="searchcontacts1" role="tabpanel" aria-labelledby="searchcontacts1-tab">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="row mb-3">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme coverimg">
                                                <img src="assets/img/user-2.jpg" alt="" />
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">Ms. Switty David</a>
                                            <p class="text-truncate text-secondary small">US, UK Recruiter</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme coverimg">
                                                <img src="assets/img/user-3.jpg" alt="" />
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">Dyna Roosevelt</a>
                                            <p class="text-truncate text-secondary small">Marketing Head at Linmongas</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="row mb-3">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme coverimg">
                                                <img src="assets/img/user-4.jpg" alt="" />
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">Mr. Freddy Johnson</a>
                                            <p class="text-truncate text-secondary small">Project Manager</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-auto">
                                            <div class="avatar avatar-50 rounded bg-light-theme coverimg">
                                                <img src="assets/img/user-1.jpg" name="userimage" alt="" />
                                            </div>
                                        </div>
                                        <div class="col-8 ps-0 align-self-center">
                                            <a href="#" class="text-truncate">The Maxartkiller</a>
                                            <p class="text-truncate text-secondary small">CEO Maxartkiller</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--USER PROFILE-->
        <div class="ms-auto">
            <div class="row gx-3 align-items-center">
                <div *ngIf="false" class="col-auto">
                    <button class="btn btn-square btn-link search-btn" id="searchtoggle" (click)="openSearch = true;">
                        <i class="bi bi-search"></i>
                    </button>
                    <button type="button" class="btn btn-square btn-link text-center" id="addtohome" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Install PWA"><i class="bi bi-cloud-download"></i></button>
                    <button type="button" class="btn btn-square btn-link text-center" id="showNotification" (click)="rightbaropennotification()" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Notifications">
                        <span class="bi bi-bell position-relative">
                            <span class="position-absolute top-0 start-100 p-1 bg-danger border border-light rounded-circle">
                                <span class="visually-hidden">New alerts</span>
                            </span>
                        </span>
                    </button>
                </div>
                <div class="col-auto">
                    <div class="dropdown">
                        <!--IF LG VIEW-->
                        <a class="dd-arrow-none dropdown-toggle tempdata" id="userprofiledd" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                            <div class="row" *ngIf="user">
                                <div class="col-auto align-self-center">
                                    <figure class="avatar avatar-36 top-0 rounded-circle coverimg vm">
                                        <img [src]="user.profileImgUrl" alt="" id="userimage" name="userimage" />
                                    </figure>
                                </div>
                                <div class="col ps-0 align-self-center d-none d-lg-block">
                                    <p class="mb-0">
                                        <span class="text-dark username">{{ user.fullname }}</span><br>
                                        <small class="small">{{user.plant.name}}</small>
                                    </p>
                                </div>
                                <div class="col ps-0 align-self-center d-none d-lg-block">
                                    <i class="bi bi-chevron-down small vm"></i>
                                </div>
                            </div>
                        </a>
                        <!--IF SMALL VIEW-->
                        <div class="dropdown-menu dropdown-menu-end w-250" aria-labelledby="userprofiledd">
                            <div class="dropdown-info bg-theme">
                                <div class="row" *ngIf="user">
                                    <div class="col-auto">
                                        <figure class="avatar avatar-50 rounded-circle coverimg vm">
                                            <img [src]="user.profileImgUrl" alt="" id="userphotoonboarding3" name="userimage" />
                                        </figure>
                                    </div>
                                    <div class="col align-self-center ps-0">
                                        <h6 class="mb-0"><span class="username">{{ user.fullname }}</span></h6>
                                        <p class="text-muted small">{{user.plant.name}}</p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div><a class="dropdown-item" routerLink="/pages/profile/professional" routerLinkActive="active">My Profile</a></div> -->
                            <!-- <div>
                                <a class="dropdown-item" routerLink="/pages/dashboard/home/">
                                    <div class="row g-0">
                                        <div class="col align-self-center">My Dashboard</div>
                                        <div class="col-auto">
                                            <figure class="avatar avatar-20 coverimg rounded-circle">
                                                <img src="assets/img/user-2.jpg" alt="" />
                                            </figure>
                                            <figure class="avatar avatar-20 coverimg rounded-circle">
                                                <img src="assets/img/user-3.jpg" alt="" />
                                            </figure>
                                            <figure class="avatar avatar-20 coverimg rounded-circle">
                                                <img src="assets/img/user-4.jpg" alt="" />
                                            </figure>
                                            <div class="avatar avatar-20 bg-theme rounded-circle">
                                                <small class="fs-10 vm">9+</small>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div> -->
                            <!-- <div class="dropdown open-left dropdown-dontclose">
                                <a class="dropdown-item" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                                    <div class="row">
                                        <div class="col">Subscription</div>
                                        <div class="col-auto pe-0">
                                            <p class="small text-success">Upgrade</p>
                                        </div>
                                        <div class="col-auto ps-0"><span class="arrow bi bi-chevron-right"></span></div>
                                    </div>
                                </a>
                                <div class="dropdown-menu">
                                    <div><a class="dropdown-item" routerLink="/pages/other/plan/" routerLinkActive="active">Plan</a></div>
                                    <div><a class="dropdown-item" routerLink="/pages/other/earning/" routerLinkActive="active">Earning</a></div>
                                    <div><a class="dropdown-item" routerLink="/pages/other/payment/" routerLinkActive="active">Payment</a></div>
                                    <div><a class="dropdown-item" routerLink="/pages/other/statement/" routerLinkActive="active">Statement</a></div>
                                </div>
                            </div> -->
                            <div><a class="dropdown-item" routerLink="/users/profile/" routerLinkActive="active">{{ 'profile' | translate}}</a></div>
                            <!-- <div><a class="dropdown-item" routerLink="/tools/" routerLinkActive="active">{{ 'tools' | translate}}</a></div> -->
                            <div class="dropdown open-left dropdown-dontclose">
                                <a class="dropdown-item" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                                    <div class="row">
                                        <div class="col">{{ 'tools' | translate}}</div>
                                        <div class="col-auto ps-0"><span class="arrow bi bi-chevron-right"></span></div>
                                    </div>
                                </a>
                                <div class="dropdown-menu">
                                    <div>
                                        <a class="dropdown-item c-pointer" routerLink="/tools/" routerLinkActive="active">{{ 'clearCache' | translate }}</a>
                                    </div>
                                    <div *ngIf="esAdmin">
                                        <a class="dropdown-item c-pointer" (click)="irAsignacionDocs()">{{ 'reassignDocs' | translate }}</a>
                                    </div>
                                    <div *ngIf="esAdmin">
                                        <a class="dropdown-item c-pointer" (click)="irRevisionAnual()">{{ 'sop.annualReview.title' | translate }}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="dropdown open-left dropdown-dontclose">
                                <a class="dropdown-item" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                                    <div class="row">
                                        <div class="col">{{ 'language' | translate}}</div>
                                        <div class="col-auto pe-0"><small class="vm">{{currentLng}}</small> <i class="bi bi-translate"></i></div>
                                        <div class="col-auto ps-0"><span class="arrow bi bi-chevron-right"></span></div>
                                    </div>
                                </a>
                                <div class="dropdown-menu"> 
                                    <div>
                                        <a class="dropdown-item c-pointer" (click)="setLng('en-US')" [ngClass]="{'active': currentLngKey === 'en-US'}" data-value="EN">English</a>
                                    </div>
                                    <div>
                                        <a class="dropdown-item c-pointer" (click)="setLng('es-ES')" [ngClass]="{'active': currentLngKey === 'es-ES'}" data-value="ES">Spanish</a>
                                    </div>
                                </div>
                            </div>
                            <!-- <div><a class="dropdown-item" routerLink="/pages/profile/account-settings/" routerLinkActive="active">Account Setting</a></div> -->
                            <div><a class="dropdown-item" routerLink="/auth/login/" (click)="logout()" routerLinkActive="active">{{ 'logout' | translate}}</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</nav>